var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: 0,
    clipRule: "evenodd",
    d: "M13 9H7V3H13V9ZM6 2.5C6 2.22386 6.22386 2 6.5 2H13.5C13.7761 2 14 2.22386 14 2.5V9.5C14 9.77614 13.7761 10 13.5 10H10V13.5C10 13.7761 9.77614 14 9.5 14H2.5C2.22386 14 2 13.7761 2 13.5V6.5C2 6.22386 2.22386 6 2.5 6H6V2.5ZM6 7H3V13H9V10H6.5C6.22386 10 6 9.77614 6 9.5V7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7cb35b28826eef4b65d5600efd5ece9d.svg";
export { ForwardRef as ReactComponent };